module.exports = __webpack_public_path__ + "img/HFCBCNSHXXX.aa994d62.png";